import { makeAutoObservable } from 'mobx';
import type { Bookmark } from '../services/bookmarkStorage';

class BookmarkNavStore {
  bookmarks: Bookmark[] = [];
  currentIndex = -1;

  constructor() {
    makeAutoObservable(this);
  }

  get isActive()       { return this.currentIndex >= 0 && this.bookmarks.length > 0; }
  get hasPrev()        { return this.currentIndex > 0; }
  get hasNext()        { return this.currentIndex < this.bookmarks.length - 1; }
  get currentBookmark(): Bookmark | null {
    return this.isActive ? this.bookmarks[this.currentIndex] : null;
  }

  setContext(bookmarks: Bookmark[], index: number) {
    this.bookmarks = bookmarks;
    this.currentIndex = index;
  }

  clear() {
    this.bookmarks = [];
    this.currentIndex = -1;
  }

  prev() { if (this.hasPrev) this.currentIndex--; }
  next() { if (this.hasNext) this.currentIndex++; }
}

export const bookmarkNavStore = new BookmarkNavStore();
